import type { CheckoutConfig } from '#types/config/components/checkout'

export default {
  minimumLoyaltyAmount: '25',
  minimumLoyaltyPoints: 250
} satisfies CheckoutConfig['paymentLoyalty']
